import React from 'react'

import { isViewingSharedClean } from 'app/fieldapp/components/schedule/schedule.utils'

import { NavTab, NavTabConfig } from './NavTab'

import styles from './NavTabWrapper.module.scss'

export type NavTabWrapperProps = {
  configs: NavTabConfig[]
  current: string
  navigateTo: (route: string) => void
}

export const NavTabWrapper: React.FC<NavTabWrapperProps> = React.memo(
  ({ configs, ...props }) => {
    const shouldRender = !isViewingSharedClean()

    return shouldRender ? (
      <nav className={styles.navTabWrapper}>
        {configs.map(config => (
          <NavTab config={config} key={config.route} {...props} />
        ))}
      </nav>
    ) : null
  },
)
